import { useState } from "react";
import { GetAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";
type TSearchFields = {
  name: string;
  email: string;
  companyId: string;
  search: string;
  page: number;
  record: number;
};

const useSupplier = ({
  label = "",
  value = "",
}: {
  label: string;
  value: string;
}) => {
  const [options, setOptions] = useState<any[]>([]);
  const [searchFields, setSearchFields] = useState({
    name: "",
    email: "",
    companyId: "",
    page: 1,
    record: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [optionErrorMsg, setOptionErrorMsg] = useState("");
  const [selectOption, setSelectOption] = useState<any>({
    label: label,
    value: value,
  });
  const onOpen = () => {
    getAsyncOptions();
  };

  const getAsyncOptions = async (searchField_?: Partial<TSearchFields>) => {
    let searchField = {
      ...searchFields,
      ...searchField_,
    };
    setLoading(true);
    GetAsync(`${API_GATEWAY}/api/vendorService/Suppliers`, true, undefined, {
      params: {
        name: searchField.name || undefined,
        email: searchField.email || undefined,
        companyId: searchField.companyId || undefined,
        page: searchField.page || undefined,
        record: searchField.record || undefined,
        searchvalue: searchField.search || undefined,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setOptions(res?.data?.suppliers);
          setTotalCount(res?.data?.filteredRecordsCount);
          if (optionErrorMsg !== "") {
            setOptionErrorMsg("");
          }
        } else if (res.status === 400) {
          setOptionErrorMsg(res.data.Detail);
          if (options?.length > 0) {
            setOptions([]);
          }
        } else {
          if (options?.length > 0) {
            setOptions([]);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return {
    options,
    selectOption,
    setSelectOption,
    getAsyncOptions,
    totalCount,
    loading,
    searchFields,
    optionErrorMsg,
    onOpen,
  };
};
export default useSupplier;
